module.exports = __webpack_public_path__ + "media/images/hbt_doors-8bbe4953c9547abe9c713cc82234b30d.png";